import React from 'react';

import { useSportsbookState } from '@atlas/core';
import { EmptyStateView } from '@atlas/ui';

const SportsbookLoader = props => {
  const { error } = useSportsbookState();

  if (error) {
    return (
      <EmptyStateView
        className="fullscreen"
        description="sportsbook_no_events_message"
        title="sportsbook_no_events"
      />
    );
  }
  return props.children;
};

export default SportsbookLoader;
